import { useEffect, useRef } from 'react'

export default function SkipToContent() {
  const linkRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Tab' && linkRef.current) {
        linkRef.current.focus()
      }
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [])

  return (
    <a
      ref={linkRef}
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-lg focus:shadow-lg focus:outline-none"
      aria-label="Aller au contenu principal"
    >
      Aller au contenu principal
    </a>
  )
}
